const users = {
  permissionSource: 'plugin::users-permissions.user',
  creationTitle: 'Create User',
  creationEndPoint: '/users',
  detailTitle: 'User: :title',
  detailEndPoint: '/users/:id',
  detail: [
    {
      isLayout: true,
      layoutPattern: '1-1',
      children: [
        {
          isLayout: true,
          layoutPattern: '1',
          children: [
            {
              label: 'Username',
              value: 'username',
              tag: 'input',
              type: 'text',
              required: true,
            },
            {
              label: 'Email',
              value: 'email',
              tag: 'input',
              type: 'email',
              placeholder: 'User Login Email',
              required: true,
            },
            {
              label: 'User Role',
              value: 'role',
              tag: 'single-select',
              dataSourceUrl: '/users-permissions/roles',
              dataLabel: 'name',
            },
            {
              label: 'Staff',
              value: 'staff',
              tag: 'single-select',
              dataSourceUrl: '/staffs',
              dataLabel: 'name',
            },
            {
              label: 'Blocked user account',
              value: 'blocked',
              tag: 'switch',
            },
          ],
        },
        {
          isLayout: true,
          layoutPattern: '1',
          children: [
            {
              label: 'Avatar',
              value: 'avatar',
              tag: 'media',
              acceptFile: 'image/*',
            },
          ],
        },
      ],
    },
    {
      isLayout: true,
      layoutPattern: '1-1-1',
      children: [
        {
          label: 'Create Date / Time',
          value: 'custom_created_at',
          tag: 'static-text',
        },
        {
          label: 'Update Date / Time',
          value: 'custom_updated_at',
          tag: 'static-text',
        },
      ],
    },
  ],
  creationForm: [
    {
      label: 'Username',
      value: 'username',
      tag: 'input',
      type: 'text',
      required: true,
    },
    {
      label: 'Email',
      value: 'email',
      tag: 'input',
      type: 'email',
      placeholder: 'User Login Email',
      required: true,
    },
    {
      label: 'Password',
      value: 'password',
      tag: 'input',
      type: 'password',
      required: true,
    },
  ],
}
export default users
